<template>
    <v-select v-model="modelValue" v-bind="{ ...attrs_select_common, ...$attrs }" class="rounded-0 v-text-field--underlined" @change="emit">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-select>
</template>

<script>
import { attrs_select_common } from "@/assets/variables";

export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        modelValue: null,
        attrs_select_common,
    }),
    methods: {
        sync() {
            this.modelValue = this.value;
        },
        emit() {
            this.$emit("input", this.modelValue);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
